import React from 'react'
import { Link } from 'react-router-dom'
import locale, {langPrefix} from 'shared/i18n/react'

class NotFound extends React.Component {
  constructor(props) {
    super(props)
    this.langPrefix = langPrefix()
  }

  render() {
    return (
      <div className="flex flex-center full-bg center-align text-no-spacing">
        <div>
          <h1 className="screamer">404</h1>
          <p className="screamer-subheader">{locale.notFound}</p>
          <div className="section">
            <Link to={`/${this.langPrefix}`} className="btn btn-unicorn">{locale.buttons.backHome}</Link>
          </div>
        </div>
      </div>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./assets/js/components/notfound.jsx